module.exports = __webpack_public_path__ + "84dab55fbd729cab95594aaf7886fd8e.svg";